module.exports = __webpack_public_path__ + "media/images/service/tech_bg-f57518fabe862479f6a8172cb0e5f472.png";